<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="alert alert-light" role="alert" *ngIf="isAdmin">
        <p class="alert-heading mb-0">Sie sind Administrator und können Benutzer hinzufügen und löschen</p>
      </div>
      <div class="alert alert-light" role="alert" *ngIf="!isAdmin">
        <p class="alert-heading mb-0">Sie können keine Benutzer hinzufügen oder löschen.</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">

          <div class="table-responsive">
            <table class="table">
              <thead>
              <th colspan="2">Administratoren</th>
              <th>
                <div class="btn-group">
                  <!-- Button -->
                  <button (click)="addAdmin()" class="btn btn-outline-primary mr-2">
                    Admin hinzufügen
                  </button>

                  <button (click)="addUser()" class="btn btn-outline-primary">
                    User hinzufügen
                  </button>
                </div>
              </th>
              </thead>
              <tbody>
                <tr *ngIf="admins?.length === 0">
                  <td colspan="3">
                    Keine
                  </td>
                </tr>
                <tr *ngFor="let a of admins">
                  <td style="width: 70px;">
                    <scfe-user-circle [user]="a"></scfe-user-circle>
                  </td>
                  <td class="pt-4"><span>{{ a.FirstName }} {{ a.LastName }} ({{ a.EMail }})</span></td>
                  <td style="width: 70px;">
                    <span *ngIf="!a.IsSelf" class="fe fe-trash" (click)="delete(a);"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <th colspan="3">Anwender</th>
              </thead>
              <tbody>
                <tr *ngIf="users?.length === 0">
                  <td colspan="3">
                    Keine
                  </td>
                </tr>
                <tr *ngFor="let a of users">
                  <td style="width: 70px;">
                    <scfe-user-circle [user]="a"></scfe-user-circle>
                  </td>
                  <td class="pt-4"><span>{{ a.FirstName }} {{ a.LastName }} ({{ a.EMail }})</span></td>
                  <td style="width: 70px;">
                    <span *ngIf="!a.IsSelf" class="fe fe-trash" (click)="delete(a);"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #userModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title">{{ newUser.IsAdmin ? 'Admin' : 'Benutzer' }} hinzufügen</h2>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form novalidate (ngSubmit)="save(form)" #form="ngForm">
    <div class="modal-body">

      <div class="row mb-1 form-group">
        <div class="col-md-3">
          E-Mail
        </div>
        <div class="col-md-9">
          <input class="form-control" name="eMail" #eMail="ngModel" [(ngModel)]="newUser.EMail" required />
        </div>
        <div *ngIf="submitted">
          <ul class="text-danger list-unstyled">
            <li *ngIf="eMail.errors?.required">
              Sie müssen eine E-Mail-Adresse eingeben
            </li>
          </ul>
        </div>
      </div>
      <div class="row mb-1 form-group">
        <div class="col-md-3">
          Vorname
        </div>
        <div class="col-md-9">
          <input class="form-control" name="firstName" required #firstName="ngModel" [(ngModel)]="newUser.FirstName" required />
        </div>
        <div class="" *ngIf="submitted">
          <ul class="text-danger list-unstyled">
            <li *ngIf="firstName.errors?.required">
              Sie müssen einen Vornamen eingeben
            </li>
          </ul>
        </div>
      </div>
      <div class="row mb-1 form-group">
        <div class="col-md-3">
          Nachname
        </div>
        <div class="col-md-9">
          <input class="form-control" name="lastName" required #lastName="ngModel" required [(ngModel)]="newUser.LastName" />
        </div>
        <div class="col-12" *ngIf="submitted">
          <ul class="text-danger list-unstyled">
            <li *ngIf="lastName.errors?.required">
              Sie müssen einen Nachnamen eingeben
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="text-danger">{{errorMessage}}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-danger" (click)="d();">Abbrechen</button>
      <button class="btn btn-success" type="submit">Hinzufügen</button>
    </div>
  </form>
</ng-template>
